import { Injectable } from "@angular/core";
import { CreateOrderRequestModel, OrderClient } from "src/domain/client";
import { ChannelRequestService } from "./channel-request.service";
import { ShoppingCartService } from "./shopping-cart.service";
import { TrackingService } from "./tracking.service";
import { EcomProductArrayPipe } from "src/pipes/ecom-product.pipe";

@Injectable({
  providedIn: "root",
})
export class OrderService {
  constructor(
    private channelRequestService: ChannelRequestService,
    private shoppingCartService: ShoppingCartService,
    private trackingService: TrackingService,
    private ecomProductArrayPipe: EcomProductArrayPipe,
  ) {}

  private async trackPurchaseOnSuccess(
    requestModel: CreateOrderRequestModel,
    fn: (
      channelRequestId: string,
    ) => number | null | PromiseLike<number | null>,
  ): Promise<void> {
    if (!this.channelRequestService.channelRequest?.channelRequestId) {
      return Promise.reject(new Error("No channelRequestId specified"));
    }
    const channelRequetId =
      this.channelRequestService.channelRequest?.channelRequestId;
    const ecomProducts = this.ecomProductArrayPipe.transform(
      this.shoppingCartService.shoppingCart,
    );
    const orderId = await fn(channelRequetId);
    if (orderId != null) {
      this.trackingService.trackPurchaseCompleteEcom(
        ecomProducts,
        orderId,
        undefined,
        requestModel.contactCustomer,
      );
    }
  }

  createOrder(requestModel: CreateOrderRequestModel): Promise<void> {
    this.trackingService.trackOrderSubmit();
    return this.trackPurchaseOnSuccess(
      requestModel,
      async (channelRequestId) => {
        const response = await new OrderClient().create(
          channelRequestId,
          requestModel,
        );
        this.channelRequestService.setChannelRequest(response.channelRequest);
        return response.orderNumber ?? null;
      },
    );
  }

  getOrderId(shoppingCartId: string): Promise<number> {
    return new OrderClient().orderNr(shoppingCartId);
  }
}
